import React, { useState } from 'react';
import { Box, TextField, Typography } from '@mui/material';
import { QuestionnaireItemType } from '../../../../_helpers';
import QuestionFileUpload from '../../QuestionFileUpload';
import { useTranslation } from 'react-i18next';

const TextQuestion = ({ q, sectionIndex, handleChange, error, formData, setFormData, isDisabled, handleFiles }) => {
    const { t } = useTranslation()
    const [answers, setAnswers] = useState((q.answers || []))
    
    return (
        <Box>
            <TextField
                fullWidth
                multiline={q.type === QuestionnaireItemType.Paragraph}
                placeholder={
                    q.type === QuestionnaireItemType.Paragraph
                        ? t('questionnaire.form.longAnswerText')
                        : t('questionnaire.form.shortAnswerText')
                }
                value={answers?.[0] || ''}
                onChange={(e) => {
                    if (handleChange) {
                        handleChange(sectionIndex, q, [e.target.value])
                        setAnswers([e.target.value])
                    }
                }}
            />
            <QuestionFileUpload
                q={q}
                sectionIndex={sectionIndex}
                isDisabled={isDisabled}
                handleFiles={handleFiles}
            />
            {error && (
                <Typography variant="body2" color="error" sx={{ mt: 1 }}>
                    {error}
                </Typography>
            )}
        </Box>
    );
};

export default TextQuestion;
